module.exports = __webpack_public_path__ + "media/reskin-images/icon--circle-check-5f4be4c2.svg";